import React, { FC } from 'react';

import { Button } from '@/shared/components/Button/Button';

import { useI18n } from '../../hooks/useI18n';
import { useSeasonsMetadataQuery } from '../../hooks/useSeasonsMetadataQuery';

import { SeasonInfo } from './_SeasonInfo';
import styles from './_SeasonHeader.module.css';

interface SeasonHeaderProps {
    filmId: string;
    seasonId: string;
    onOpenAllSeasons: VoidFunction;
}

export const SeasonHeader: FC<SeasonHeaderProps> = ({ filmId, seasonId, onOpenAllSeasons }) => {
    const {
        seasonsMetadata: { items: seasons },
    } = useSeasonsMetadataQuery({ id: filmId });

    const i18n = useI18n();

    const currentSeason = seasons.find(({ contentId }) => contentId === seasonId);

    if (!currentSeason || seasons.length === 0) {
        return null;
    }

    return (
        <div className={styles.seasonHeader}>
            <SeasonInfo
                number={currentSeason?.number}
                episodesCount={currentSeason?.episodesCount}
            />
            {seasons.length > 1 && (
                <Button onClick={onOpenAllSeasons} variant="secondary" size={32} theme="dark">
                    {i18n('series_navigator__all_seasons')}
                </Button>
            )}
        </div>
    );
};
